export default "__VITE_ASSET__CYN6aLNO__"